/* global jQuery */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process
const overlayMenu = require('../components/overlay-menu');


function wireEvents() {

    var query_size = $('.my-product-photo__shadow-comp').attr('data-size');
    sizesToDefault();
    $('.my-product-info__sizes li[data-size='+query_size+']').addClass('clicked');
    showSizeContent(query_size, 'box', 0);

    // Product shot zoom using jquery-zoom. For responsive views.
    $('.my-product-photo__package.jz').each(function() {
        var zoom_img_url = $(this).attr('zoomsrc');
        $(this).zoom({url: zoom_img_url});
    });
    // Product shot zoom using elevateZoom. For desktop views.
    // var box_width = $('.my-product-photo__package.ez .my-product-photo__img').width();
    var box_height = $('.my-product-photo__package.ez .my-product-photo__img').height();
    var box_width = $('.my-product-info').width();
    var my_offset = $('.zoomWindow').width()/2 + 10;
    // console.log($('.my-product-photo').css('margin-right'));
    var ezoom_settings = {
        responsive: true,
        // zoomWindowPosition: -1,
        zoomWindowOffetx: 10,
        zoomWindowPosition: 'my-product-info',
        zoomWindowWidth: box_width,
        // zoomWindowHeight: box_width,
        borderSize: 0
    };
    $('.my-product-photo__package.ez .my-product-photo__img').elevateZoom(ezoom_settings);

    // Product sizes nav/selector.
    $('.my-product-info__sizes li').click(function() {
        sizesToDefault();
        $(this).addClass('clicked');
        showSizeContent($(this).attr('data-size'), $(this).attr('package-type'), 400);
    });

    // Refresh package art when browser is resized.
    var refreshForSize;
    $(window).resize(function() {
        clearTimeout(refreshForSize);
        refreshForSize = setTimeout(resized, 0);
    });
    function resized() {
        // console.log('resized()');
        var current_size = $('.my-product-info__sizes li.clicked').attr('data-size');
        var current_type = $('.my-product-info__sizes li.clicked').attr('package-type');
        showSizeContent(current_size, current_type, 0);
    }

    function sizesToDefault() {
        $('.my-product-info__sizes li').removeClass('clicked');
    }

    function showSizeContent(size, type, fadeTime) {
        hideAllSizeContent();
        resetInstructions();
        // Show correct packaging image.
        if ($(window).width() >= 1024) {
            var $box_image_div = $('.my-product-photo__package.ez[data-size='+size+']');
        } else {
            $box_image_div = $('.my-product-photo__package.jz[data-size='+size+']');
        }
        $box_image_div.fadeIn(fadeTime);
        $('.my-product-photo__shadow.'+type).fadeIn(fadeTime);
        // Tag package + shadow container w/correct size.
        $('.my-product-photo__shadow-comp').attr('data-size', size);
        // Tag cooking instructions button w/correct size.
        $('.cooking-instructions__button').attr('data-size', size);
        // Show correct nutrition facts link. Each link is assigned a different image.
        $('.my-product-info__links .link-arrow[data-size='+size+']').css('display', 'block');
        // Is this size product packaged in box or bag?
        $('.my-product-photo').attr('package-type', type);
    }

    function hideAllSizeContent() {
        $('.my-product-photo__package').css('display', 'none');
        $('.my-product-photo__shadow').css('display', 'none');
        $('.cooking-instructions__panel').css('display', 'none');
        $('.my-product-info__links .link-arrow').css('display', 'none');
    }

    // Cooking Instructions expand/collapse.
    $('.cooking-instructions__button').click(function() {
        var my_size = $(this).attr('data-size');
        // console.log('COOKING INSTRUCTIONS : '+my_size);
        var $my_instructions = $('.cooking-instructions__panel[data-size='+my_size+']');
        $('.cooking-instructions .icon-openclose').toggleClass('closed');
        $('.cooking-instructions .icon-openclose').toggleClass('open');
        $('.cooking-instructions .icon-open').toggleClass('is-visuallyhidden');
        $('.cooking-instructions .icon-close').toggleClass('is-visuallyhidden');
        if ($my_instructions.css('display') == 'none') {
            $my_instructions.slideDown();
            $('html, body').animate({
                scrollTop: $('.cooking-instructions__button').offset().top
            }, 300);
        } else {
            $my_instructions.slideUp();
            $('html, body').animate({
                scrollTop: 0
            }, 300);
        }
    });
    function resetInstructions() {
        $('.cooking-instructions .icon-openclose').removeClass('closed');
        $('.cooking-instructions .icon-openclose').removeClass('open');
        $('.cooking-instructions .icon-openclose').addClass('closed');
    }

    // Nutrition info lightbox.
    $('.my-product-info__links .link-arrow').click(function(e) {
        e.preventDefault();
        var image_href = $(this).attr('imageUrl');
        var image_html =
                    '<div class="nutri-info__image">' +                    
                        '<div class="nutri-info__header">' +
                            '<div class="overlay-menu__close">' +
                                '<a href="#" class="overlay-menu__close-link"><span class="icon-close"></span></a>' +
                            '</div>' +
                        '</div>' +
                        '<img src="' + image_href + '" />' +
                    '</div>';

        if ($('.nutri-info-lightbox').length > 0) {
            $('#nutri-content').html(image_html);
            $('.nutri-info-lightbox').fadeIn();
        } else {
            var lightbox =
            '<div class="nutri-info-lightbox">' +
                '<div id="nutri-content">' +
                    image_html +
                '</div>' +
            '</div>';
            $('body').append(lightbox);
            $('.nutri-info-lightbox').fadeOut(0);
            $('.nutri-info-lightbox').fadeIn();
        }
    });

    $('body').on('click', '.nutri-info-lightbox', function() {
        $('.nutri-info-lightbox').fadeOut();
    });

    // Hook up 'Find a Store' button
    $('.js-find-a-store').click(function(event){
        event.preventDefault();
        overlayMenu.showSearchForm();
    });
}

exports.init = function() {
    // Do product detail page initialization...
    wireEvents();
};